import styled from 'styled-components'
import {
  Container as BaseContainer,
  CreateButtonDiv as BaseCreateButtonDiv,
  CreateButtonText as BaseCreateButtonText,
  DangerButtonDiv as BaseDangerButtonDiv,
  HeaderText as BaseHeaderText,
  InputDiv as BaseInputDiv,
  InputField as BaseInputField,
  LabelCreate as BaseLabelCreate,
  ModalActionsColumn as BaseModalActionsColumn,
  SelectField as BaseSelectField,
} from '../CreateAccessUserModal/style'

export const HeaderText = styled(BaseHeaderText)`
  font-size: 1.45rem;
`

export const LabelCreate = styled(BaseLabelCreate)`
  font-size: 0.82rem;
`

export const WarningText = styled.span`
  color: #EF4444;
  font-size: 0.75rem;
  margin-top: 0.25rem;
  display: block;
  font-family: 'Inter', sans-serif;
`

export const Container = styled(BaseContainer)`
  padding: 1.5rem 1.8rem;
  width: 54rem;
  max-width: 92vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
`

export const RichHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 0.75rem;
`

export const UserInfoGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.85rem;
`

export const UserAvatar = styled.div`
  width: 2.3rem;
  height: 2.3rem;
  border-radius: 50%;
  background-color: #E2F0FD;
  color: #0082C5;
  font-weight: 700;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Inter', sans-serif;
  text-transform: uppercase;
`

export const UserDetailsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
`

export const UserNameTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
`

export const UserNameTitle = styled.h2`
  font-size: 1.15rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
  font-family: 'Inter', sans-serif;
`

export const UserMetaInfo = styled.span`
  font-size: 0.82rem;
  color: #6B7280;
  font-family: 'Inter', sans-serif;
`

export const BadgeItem = styled.span<{ variant?: 'warning' | 'danger' | 'info' }>`
  font-size: 0.7rem;
  padding: 0.2rem 0.55rem;
  border-radius: 12px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  background-color: ${({ variant }) =>
    variant === 'danger' ? '#FEE2E2' : variant === 'warning' ? '#FEF3C7' : '#E0F2FE'};
  color: ${({ variant }) =>
    variant === 'danger' ? '#DC2626' : variant === 'warning' ? '#D97706' : '#0369A1'};
`

export const TabsNavContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.75rem;
  border-bottom: 1px solid #E5E7EB;
  margin-top: 0.5rem;
  margin-bottom: 1.25rem;
  width: 100%;
`

export const TabNavItem = styled.button<{ isActive: boolean }>`
  background: none;
  border: none;
  padding: 0.65rem 0.25rem;
  font-size: 0.9rem;
  font-weight: ${({ isActive }) => (isActive ? '700' : '500')};
  color: ${({ isActive }) => (isActive ? '#0082C5' : '#6B7280')};
  border-bottom: ${({ isActive }) => (isActive ? '2px solid #0082C5' : '2px solid transparent')};
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: #0082C5;
  }
`

export const ModalBodyContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 0.3rem;
`

export const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.65rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid #F3F4F6;
  width: 100%;
`

export const RightFooterActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.65rem;
`

export const SecondaryButton = styled.button`
  background-color: transparent;
  border: 1px solid #D1D5DB;
  color: #374151;
  padding: 0.45rem 1.2rem;
  border-radius: 20px;
  font-size: 0.84rem;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: background 0.15s ease-in-out;

  &:hover {
    background-color: #F9FAFB;
  }
`

export const PrimaryButton = styled.button`
  background-color: #0082C5;
  border: none;
  color: #ffffff;
  padding: 0.45rem 1.3rem;
  border-radius: 20px;
  font-size: 0.84rem;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  transition: background 0.15s ease-in-out;

  &:hover {
    background-color: #006CA7;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const DangerOutlineButton = styled.button`
  background-color: transparent;
  border: 1px solid #FCA5A5;
  color: #DC2626;
  padding: 0.45rem 1.2rem;
  border-radius: 20px;
  font-size: 0.84rem;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: background 0.15s ease-in-out;

  &:hover {
    background-color: #FEF2F2;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const InputDiv = styled(BaseInputDiv)`
  gap: 0.35rem;
  margin-top: 0.5rem;
  width: 100%;
`

export const InputField = styled(BaseInputField)`
  height: 4.4vh;
  min-height: 2.25rem;
  font-size: 0.88rem;
  padding-left: 0.85vw;
  padding-right: 0.85vw;
  border-radius: 1.6vw;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    background-color: #f3f4f6;
  }
`

export const SelectField = styled(BaseSelectField)`
  height: 4.4vh;
  min-height: 2.25rem;
  font-size: 0.88rem;
  padding-left: 0.85vw;
  padding-right: 0.85vw;
  border-radius: 1.6vw;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    background-color: #f3f4f6;
  }
`

export const SectionTitle = styled.h3`
  font-size: 0.78rem;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  margin-top: 1.35rem;
  margin-bottom: 0.5rem;
  letter-spacing: 0.04em;
  font-family: 'Inter', sans-serif;
`

export const Grid2Cols = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
  width: 100%;
`

export const Grid4Cols = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;
  width: 100%;
`

export const CalloutBox = styled.div`
  background-color: #FAFAFA;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 0.6rem 0.85rem;
  font-size: 0.78rem;
  color: #4B5563;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-family: 'Inter', sans-serif;
`

export const CompositionBox = styled.div`
  background-color: #FAFAFA;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 0.85rem 1rem;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`

export const CompositionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.82rem;
  color: #374151;
  padding: 0.25rem 0;
  border-bottom: 1px dashed #E5E7EB;
  font-family: 'Inter', sans-serif;

  &:last-child {
    border-bottom: none;
  }
`

export const CompositionLabel = styled.span`
  font-weight: 600;
  color: #4B5563;
`

export const CompositionValue = styled.span`
  font-weight: 600;
  color: #111827;
`

export const ActionOutlineButton = styled.button`
  background-color: #FFFFFF;
  border: 1px solid #D1D5DB;
  border-radius: 16px;
  padding: 0.4rem 0.9rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  width: fit-content;
  margin-top: 0.6rem;
  font-family: 'Inter', sans-serif;
  transition: background 0.15s ease-in-out;

  &:hover {
    background-color: #F9FAFB;
  }
`

export const ModalActionsColumn = styled(BaseModalActionsColumn)`
  margin-top: 1.15rem;
  gap: 0.75rem;
`

export const CreateButtonDiv = styled(BaseCreateButtonDiv)`
  height: auto;
  min-height: 2.65rem;
  padding: 0.65rem 1.15rem;
  border-radius: 2.2vw;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CreateButtonText = styled(BaseCreateButtonText)`
  font-size: 0.85vw;
`

export const DangerButtonDiv = styled(BaseDangerButtonDiv)`
  min-height: 2.65rem;
  padding: 0.65rem 1.15rem;
  border-radius: 2.2vw;
  font-size: clamp(0.78rem, 0.88vw, 0.92rem);
`

export const ActivateButtonDiv = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 2.65rem;
  padding: 0.65rem 1.15rem;
  border: none;
  border-radius: 2.2vw;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: clamp(0.78rem, 0.88vw, 0.92rem);
  font-weight: 700;
  background-color: #22c55e;
  color: #fff;

  :hover {
    background-color: #16a34a;
  }
`
